import { useEffect, useState, useContext } from "react";
import { UserAvatar } from "components/Avatar/UserAvatar";
import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";

export default function CurrentUserAvatar() {
  const [username, setUsername] = useState("Unknown");
  const { user } = useContext(CognitoAuthContext);

  useEffect(() => {
    setUsername(user?.fullName ?? "Unknown");
  }, [user]);

  return <UserAvatar name={username} disableTooltip={true} />;
}
